import { render, staticRenderFns } from "./ContactConsultantRelationSettingsUpdate.vue?vue&type=template&id=2d1372e6"
import script from "./ContactConsultantRelationSettingsUpdate.vue?vue&type=script&lang=js"
export * from "./ContactConsultantRelationSettingsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports